import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import CtaBand from "@/components/sections/CtaBand";
import { SectionHeading, DynIcon } from "@/components/ui-bits";
import { useServices } from "@/hooks/usePublicData";

export default function TaxiServices() {
  const { data: services = [] } = useServices();
  return (
    <>
      <Seo title="Taxi Services in Rajasthan | Local, Airport & Outstation | Chouhan Taxi Service"
        description="Explore all taxi and cab services by Chouhan Taxi Service — local, airport, one-way, round-trip, outstation, corporate and tourist taxis across Jodhpur, Jaipur, Udaipur and Jaisalmer."
        path="/taxi-services" />
      <Breadcrumbs items={[{ label: "Taxi Services" }]} />
      <section className="pt-8 pb-4">
        <div className="container-x max-w-3xl">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-extrabold text-navy-heading leading-tight">Our Taxi Services</h1>
          <p className="mt-4 text-slate-600 leading-relaxed">From everyday city rides to long outstation journeys and complete Rajasthan tours, Chouhan Taxi Service offers a full range of reliable taxi and cab services. Pick the service that fits your journey and book in minutes.</p>
        </div>
      </section>
      <section className="section-pad pt-8">
        <div className="container-x">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((sv) => (
              <Link key={sv.slug} to={`/taxi-services/${sv.slug}`} data-testid={`service-card-${sv.slug}`}
                className="group bg-white rounded-2xl p-6 border border-slate-100 shadow-sm card-hover">
                <div className="w-12 h-12 rounded-xl bg-navy flex items-center justify-center mb-4 group-hover:bg-brand transition-colors"><DynIcon name={sv.icon} className="w-6 h-6 text-white" /></div>
                <h2 className="font-heading font-semibold text-navy-heading text-lg mb-2">{sv.title}</h2>
                <p className="text-sm text-slate-600 leading-relaxed mb-3">{sv.short}</p>
                <span className="text-sm text-brand font-semibold inline-flex items-center gap-1 group-hover:gap-2 transition-all">Learn more <ArrowRight className="w-3.5 h-3.5" /></span>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
